import React from "react";
import { Outlet } from "react-router-dom";

const PartnerLeadRoot = () => {
  return <Outlet />;
};

export default PartnerLeadRoot;
